import React from 'react';
import './SettingTitle.scss';

const SettingTitle = (props) => {
    let { wrapperClass, subtitleClass, titleClass, subtitleText, titleText, reverse } = props;

    return (<div className={['setting-title-wrapper', wrapperClass].join(' ')}>
        {reverse
            ? <React.Fragment>
                <h3 className={['setting-subtitle', subtitleClass].join(' ')}>{subtitleText}</h3>
                <h2 className={['setting-title', titleClass].join(' ')}>{titleText}</h2>
            </React.Fragment>
            : <React.Fragment>
                <h2 className={['setting-title', titleClass].join(' ')}>{titleText}</h2>
                <h3 className={['setting-subtitle', subtitleClass].join(' ')}>{subtitleText}</h3>
            </React.Fragment>
        }
    </div>)
};

export default SettingTitle;
            